import CmsPageQuery from 'Query/CmsPage.query';
import OrderQuery from 'Query/Order.query';
import ProductListQuery from 'Query/ProductList.query';
import { Field } from 'Util/Query';

export const SEARCH_FIELD_PRODUCTS = 'products';
export const SEARCH_FIELD_PAGES = 'pages';
export const SEARCH_FIELD_OTHERS = 'contents';
export const SEARCH_PAGE_SIZE_DEFAULT = 5;

/** @namespace PeggysagePwa/Query/Search/Query */
export class SearchQuery {
    getQuery(type, options, onlyCount = false) {
        const {
            args: {
                search = '',
                pageSize = SEARCH_PAGE_SIZE_DEFAULT,
                currentPage = 1
            } = {}
        } = options;

        if (![SEARCH_FIELD_PRODUCTS, SEARCH_FIELD_PAGES, SEARCH_FIELD_OTHERS].includes(type)) {
            return null;
        }

        const query = new Field(type)
            .addArgument('search', 'String', search.replaceAll('%22', ''))
            .addArgument('pageSize', 'Int', pageSize)
            .addArgument('currentPage', 'Int', currentPage);

        // Filter for pages
        if (type === SEARCH_FIELD_PAGES) {
            const filter = {
                page_type: {
                    eq: 'tutorial'
                }
            };

            query.addArgument('filter', 'PageAttributeFilterInput', filter);
        }

        query.addFieldList(this._getSearchResultsFields(type, onlyCount));

        return query;
    }

    _getSearchResultsFields(type, onlyCount = false) {
        const fields = [
            '__typename',
            'total_count'
        ];

        // Do not get items if we only want the number of results
        if (!onlyCount) {
            fields.push(
                this._getItemsField(type),
                OrderQuery._getSearchResultPageInfoField()
            );
        }

        if (type === SEARCH_FIELD_PRODUCTS) {
            fields.push(ProductListQuery._getAggregationsField());
        }

        return fields;
    }

    _getItemsField(type) {
        return new Field('items')
            .addFieldList(this._getItemsFields(type));
    }

    _getItemsFields(type) {
        switch (type) {
        case SEARCH_FIELD_PRODUCTS:
            return ProductListQuery.setOptions({ isPlp: true, isSingleProduct: false })._getProductInterfaceFields(false);
        case SEARCH_FIELD_PAGES:
            return CmsPageQuery._getPageTeaserFields();
        case SEARCH_FIELD_OTHERS:
            return this._getContentsItemsFields();
        default:
            return [];
        }
    }

    _getContentsItemsFields() {
        return [
            'title',
            'url',
            'content_type',
            'id',
            'faq_category_id'
        ];
    }
}

export default new SearchQuery();
